module.exports = __webpack_public_path__ + "img/merjoeva.ef2f593b.jpg";